import * as React from 'react';

const PlusSquareOutlined24 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12.75 11.25H17v1.5h-4.25V17h-1.5v-4.25H7v-1.5h4.25V7h1.5zM20.5 19c0 .83-.67 1.5-1.5 1.5H5A1.5 1.5 0 0 1 3.5 19V5c0-.83.67-1.5 1.5-1.5h14c.83 0 1.5.67 1.5 1.5zM19 2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3" }));
PlusSquareOutlined24.Size = 24;
PlusSquareOutlined24.Title = "PlusSquareOutlined";

export { PlusSquareOutlined24 as default };
